.util-nav-list {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    @include margin-direction(bottom, 20);
    min-height: 36px;
    max-height: 36px;

    @include media-breakpoint-up(xl) {
        .container {
            padding: 0;
        }
    }

    .util-nav-items {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0;

        .util-nav-link {
            color: #FFF;
            text-decoration: none;
            @include margin-direction(right, 40);
            @include text-size(14);
            @include line-height(22);
            font-family: $font-family-primary;

            &:hover,
            &:focus {
                text-decoration: underline;
            }
        }
    }

    @include media-breakpoint-down(xl) {
        position: absolute;
        left: 0;
        top: 97px;
        width: 100%;
        max-height: none;
        min-height: auto;
        background: #42444f;

        .util-nav-items {
            display: grid;
            column-gap: 10px;
            grid-template-columns: 1fr 1fr;

            .util-nav-link {
                position: relative;
                margin-right: 0;
                text-align: center;
                @include padding-direction(top, 12);
                @include padding-direction(bottom, 12);

                &:last-of-type {
                    margin-right: 0;
                }

                &::after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 1px;
                    background: #FFF;
                }

                /* Hide the after element for the last two items */
                &:last-of-type,
                &:nth-last-of-type(2) {
                    &::after {
                        display: none;
                    }
                }

                &:hover,
                &:focus {
                    text-decoration: none;
                }
            }

            .search-wrapper {
                position: absolute;
                top: 40px;
                left: 50%;
                z-index: 18;
                transform: translateX(-50%);
            }
        }
    }
}